import { render, staticRenderFns } from "./SubTierReport.vue?vue&type=template&id=2a5b9bf1&scoped=true&"
import script from "./SubTierReport.vue?vue&type=script&lang=ts&"
export * from "./SubTierReport.vue?vue&type=script&lang=ts&"
import style0 from "./SubTierReport.vue?vue&type=style&index=0&id=2a5b9bf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5b9bf1",
  null
  
)

export default component.exports